import React from 'react'
import { useTranslation } from 'react-i18next'

import banner from 'resources/images/goldBanner.jpg'
import peter from 'resources/images/soloPeter.jpg'
import peterSolo from 'resources/images/peterIntroduce.webp'
import group from 'resources/images/group.jpg'
import group2 from 'resources/images/group2.jpg'
import group3 from 'resources/images/group3.jpg'
import qr from 'resources/images/qrcode.png'
import cn from 'utils/cn'

export default function AboutUs() {
    const {
        t,
        i18n: { language },
    } = useTranslation()
    const list = [
        {
            title: 'ourGroup.competitiveEdgesListTitle1',
            desc: 'ourGroup.competitiveEdgesLisDescription1',
        },
        {
            title: 'ourGroup.competitiveEdgesListTitle2',
            desc: 'ourGroup.competitiveEdgesLisDescription2',
        },
        {
            title: 'ourGroup.competitiveEdgesListTitle3',
            desc: 'ourGroup.competitiveEdgesLisDescription3',
        },
        {
            title: 'ourGroup.competitiveEdgesListTitle4',
            desc: 'ourGroup.competitiveEdgesLisDescription4',
        },
    ]
    return (
        <div className='bg-white text-[#333d47]'>
            <div className='w-full aspect-[18/5]  max-h-[400px] relative'>
                <img src={banner} className='w-full h-full object-center object-cover' alt='' />
                <div className='absolute top-0 left-0 w-full h-full bg-[#00000080] opacity-60'></div>
                <h1 className='absolute z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#fff] text-[4.5vw] font-medium'>
                    {t('home.aboutUs')}
                </h1>
            </div>
            <div className='bg-container py-12  flex flex-col gap-6 md:gap-10 md:flex-row md:py-15'>
                <div className='w-[320px] mx-auto'>
                    <div className='w-full h-fit'>
                        <img src={qr} className='w-full h-auto object-contain' alt={t('ourGroup.registNo')} />
                    </div>
                    <div className=' text-center text-base font-semibold'>A-B-25-06-09352</div>
                </div>
                <div className='flex-1'>
                    <h2 className='text-lg font-bold pb-4 md:text-xl'>{t('ourGroup.goldTrade')}</h2>
                    <p className='text-base font-medium whitespace-pre-wrap md:text-lg'>{t('ourGroup.qrcodeIntro')}</p>
                    <p className='pt-4'>({t('ourGroup.qrcodeRegist')})</p>
                </div>
            </div>
            {/* <div className="py-12 flex flex-col gap-6 md:py-15 lg:gap-0 lg:flex-row">
        <div className="overflow-hidden w-full h-auto lg:w-2/3 lg:h-[600px]">
          <img
            src={group}
            className="w-full h-full object-center object-cover lg:hover:scale-105 transition-all ease-in-out duration-500"
            alt=""
          />
        </div>
        <div className="w-full space-y-6 lg:space-y-0 lg:w-1/2">
          <div className="w-full  overflow-hidden h-auto lg:h-[300px]">
            <img
              src={group2}
              className="w-full h-full object-center object-cover lg:hover:scale-105 transition-all ease-in-out duration-500"
              alt=""
            />
          </div>
          <div className="w-full  overflow-hidden h-auto lg:h-[300px]">
            <img
              src={group3}
              className="w-full h-full object-center object-cover lg:hover:scale-105 transition-all ease-in-out duration-500"
              alt=""
            />
          </div>
        </div>
      </div> */}
            <div className='w-full bg-black text-white'>
                <div className='py-8 text-2xl text-center font-semibold bg-container md:text-3xl md:py-12 lg:py-15'>
                    {t('ourGroup.visionTitle')}
                    <p className='font-medium text-xl pt-4'>{t('ourGroup.vision')}</p>
                </div>
            </div>
            <div className='bg-container py-12 flex flex-col gap-6 md:gap-10 md:flex-row md:py-15 '>
                <div className='flex-1'>
                    {list.map((item, index) => (
                        <div className='pb-6' key={index}>
                            <h2 className='text-lg font-bold pb-4 md:text-xl'>{t(item.title)}</h2>
                            <p className='text-base font-medium whitespace-pre-wrap md:text-lg'>{t(item.desc)}</p>
                        </div>
                    ))}
                </div>
                <div className='w-[320px] mx-auto h-fit relative group'>
                    {/* <div className=" absolute top-[400px] z-0 left-0 right-0 bottom-0 bg-gradient-to-b from-white to-black opacity-50"></div> */}
                    <img src={peterSolo} className='w-full h-auto object-contain' alt={t('ourPeople.peter.name')} />
                    <div
                        className={cn(
                            'absolute z-10 bottom-3 group-hover:bottom-5 transition-all ease-in-out duration-300 text-lg left-4 right-4 text-white',
                        )}
                    >
                        <h4 className='font-semibold'>{t('ourPeople.peter.name')}</h4>
                        <p className='w-[70%] text-base font-medium'>{t('ourPeople.peter.intro')}</p>
                        <h4 className='font-semibold'>{t('ourPeople.peter.title')}</h4>
                    </div>
                </div>
            </div>
        </div>
    )
}
